<mt-filter
    [filterConfig]="filterConfig"
    [progressBar]="filterConfig.isLoading"
    (filterChange)="getReportCas($event)"
></mt-filter>

<div class="report-container mt-4" *ngIf="hasData || message || systemError">
    <div class="header-container">
        <div class="header">
            <div class="float-left title" *ngIf="hasData">
                {{ "report-cas" | lang | uppercase }}
                <!-- TODO: aquí hay que poner el filtrar por -->
            </div>
            <div class="float-left filters" *ngIf="hasData">
                <div class="flex-row align-items-center">
                    <div class="text">{{ "filter-by" | lang }}:</div>
                    <input
                        class="filter-image"
                        type="checkbox"
                        id="cb1"
                        [(ngModel)]="option1"
                        (click)="toggleChangeDataTable('option1')"
                        [ngStyle]="{ cursor: option1 ? 'default' : 'pointer' }"
                    />
                    <label
                        class="filter-label"
                        for="cb1"
                        [ngClass]="{ active: option1, disabledBtn: !option1 }"
                    >
                        <img
                            alt="person-gray"
                            appImageSelector
                            [imageType]="imageType"
                            [imageKey]="'person-gray'"
                        />
                    </label>

                    <input
                        class="filter-image"
                        type="checkbox"
                        id="cb2"
                        [(ngModel)]="option2"
                        (click)="toggleChangeDataTable('option2')"
                        [ngStyle]="{ cursor: option2 ? 'default' : 'pointer' }"
                    />
                    <label
                        class="filter-label"
                        for="cb2"
                        [ngClass]="{ active: option2, disabledBtn: !option2 }"
                    >
                        <img
                            alt="truck-gray"
                            aria-label="truck-gray"
                            appImageSelector
                            [imageType]="imageType"
                            [imageKey]="'truck-gray'"
                        />
                    </label>
                </div>
            </div>
            <div class="float-right" *ngIf="hasData">
                <app-button-icon
                    [image]="'download'"
                    [iconType]="'icon'"
                    [disabled]="disabledExcelBtn"
                    [spinner]="btnSpinner"
                    (clickHandler)="downloadExcel()"
                ></app-button-icon>
            </div>
            <div class="float-right float-right-search" *ngIf="hasData">
                <div
                    class="mt-input"
                    [ngClass]="{ containerNormalSize: 'normal' }"
                >
                    <input
                        type="search"
                        [ngClass]="{ blackTheme: 'dark' }"
                        class="search"
                        placeholder="{{ 'search' | lang }} ..."
                        aria-label="Search"
                        aria-describedby="search-addon"
                        [(ngModel)]="searchText"
                    />
                    <img
                        alt="search-icon"
                        appImageSelector
                        [imageType]="'icon'"
                        [imageKey]="'search'"
                        [ngClass]="{
                            normalIconPosition: 'normal',
                            pointer: 'cursor'
                        }"
                        (click)="searchTable()"
                    />
                </div>
            </div>
        </div>
    </div>

    <div [ngClass]="{ 'body-container': tableConfig }">
        <div class="d-flex flex-row message" *ngIf="message">
            <img
                class="message-img"
                appImageSelector
                [imageType]="'icon'"
                [imageKey]="'error-red'"
                alt="imagen-icon"
            />
            <span class="message-text">{{ message }}</span>
        </div>

        <app-system-error-message
            *ngIf="!!systemError"
            [message]="systemError"
        ></app-system-error-message>
        <app-main-table
            class="table-cas"
            [tableConfig]="tableConfig"
            *ngIf="hasData && tableConfig"
        ></app-main-table>
    </div>
</div>
